import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug-bachelor-of-science',
  templateUrl: './ug-bachelor-of-science.component.html',
  styleUrls: ['./ug-bachelor-of-science.component.scss']
})
export class UgBachelorOfScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
